export const initialRejectFormData = {
  comment: '',
};
